/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface HrContract { 
    id?: string;
    staff_id?: string;
    contract_category_id?: string;
    name?: string;
    sign_on_date?: Date;
    code?: string;
    affected?: Date;
    exprired?: Date;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    physical_path?: string;
    attachment_name?: string;
    contract_number?: string;
    note?: string;
    company?: string;
    description?: string;
}